import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Count, Primary, Secondary, StyledTierStats } from './styles';

export interface TierStatsProps {
    remaining?: number;
    compact?: boolean;
}

export function TierStats({ remaining = 0, compact = false }: TierStatsProps) {
    const { t: translate } = useTranslation('floorgame');

    return (
        <StyledTierStats $compact={compact}>
            <Primary>
                <Trans ns="floorgame" i18nKey="tier_stats_primary" values={{ remaining }}>
                    <Count>0</Count>
                </Trans>
            </Primary>

            <Secondary>{translate('tier_stats_secondary')}</Secondary>
        </StyledTierStats>
    );
}
